import React from 'react';
import './LeftNavBar.css';
import { BlueInfoIconTooltip } from '../../../components/common/CustomTooltip';
import UnicefIconTwo from './../../../assets/png/UNICEF Two.png';

interface LeftNavBarType {
  navItems: string[];
  currentTab: string;
  handleNavClick: (value: string) => void;
}

const LeftNavBar = (props: LeftNavBarType) => {
  const { navItems, currentTab, handleNavClick } = props;

  return (
    <div className={`navbar-container`}>
      <ol>
        {navItems.map((item) => (
        <div className={`navbar-data`} key={item}>
          <li
            key={`${item}li`}
            className={`navbar-item ${currentTab === item ? 'active' : ''}`}
            onClick={() => handleNavClick(item)}
          >
            {item}
          </li>
        </div>
        ))}
      </ol>
      <img className='unicef-img-src-log-left-navbar' src={UnicefIconTwo}/>
    </div>
  );
};
export default LeftNavBar;
